var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 0C13.9381 0 12.2666 1.67147 12.2666 3.73333C12.2689 5.7942 13.9391 7.46433 15.9999 7.46667C18.0618 7.46667 19.7333 5.7952 19.7333 3.73333C19.7333 1.67147 18.0618 0 15.9999 0ZM15.9999 6.4C14.5272 6.4 13.3333 5.20607 13.3333 3.73333C13.335 2.26133 14.5279 1.0684 15.9999 1.06667C17.4727 1.06667 18.6666 2.2606 18.6666 3.73333C18.6666 5.20607 17.4727 6.4 15.9999 6.4Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5996 8H14.3996C11.7499 8.00293 9.60254 10.1503 9.59961 12.8V21.8667H11.7329V32H12.7996V19.7333H11.7329V20.8H10.6663V12.8C10.6686 10.7391 12.3387 9.069 14.3996 9.06667H17.5996C19.6605 9.069 21.3306 10.7391 21.3329 12.8V20.8H20.2663V19.7333H19.1996V32H20.2663V21.8667H22.3996V12.8C22.3967 10.1503 20.2493 8.00293 17.5996 8Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5335 21.8667H15.4668V32H16.5335V21.8667Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlone);
export default __webpack_public_path__ + "static/media/alone.d37d844f68ac769d517add41b6e2d865.svg";
export { ForwardRef as ReactComponent };